<template>
  <div>
    <table
      class="table"
      v-if="templateList.length != 0"
      style="table-layout: fixed"
    >
      <thead>
        <tr>
          <th>Title</th>
          <!-- <th>Used by</th> -->
          <!-- <th>Template</th> -->
          <th>Created By</th>
          <th class="link" v-on:click="sorting('created_on', $event)">
            Created On
            <i
              class="sort fa"
              :class="
                sort.field == 'created_on'
                  ? sort.order == 'asc'
                    ? 'fa-arrow-up'
                    : 'fa-arrow-down'
                  : ''
              "
            ></i>
          </th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in templateList"
          :key="item.id"
          :class="index % 2 == 0 ? 'even' : ''"
        >
          <td valign="top">
            {{ item.title }}
            <sup v-if="item.default_val" style="color: red">
              <i class="fa fa-star" aria-hidden="true"></i
            ></sup>
            <p
              v-if="item.type"
              style="text-transform: capitalize"
              class="label label-info"
            >
              {{ item.type }}
            </p>
          </td>
          <!-- <td style = "text-transform:capitalize">{{item.added}}</td> -->
          <!-- <td v-html = "item.template"></td> -->
          <td>{{ item.created_by }}</td>
          <td>{{ item.created_on | formatDate }}</td>
          <td valign="top">
            <div>
              <button
                type="button"
                class="btn btn-primary"
                @click="showPreview(item)"
              >
                Preview
              </button>
            </div>
          </td>
          <td v-if="!item.default_val">
            <div class="row-add-edit" id="template-list-drop-down">
              <a
                href="javascript:void(0)"
                class="item-add-edit"
                data-toggle="dropdown"
              ></a>
              <div
                class="dropdown-menu remove-style"
                aria-labelledby="dropdownMenuButton"
                style=""
                id="product-list-data"
              >
                <a
                  class="grid-item ico-edit"
                  href="javascript:void(0)"
                  @click="editItem(item)"
                  >Edit</a
                >
                <a
                  class="grid-item ico-delete"
                  href="javascript:void(0)"
                  @click="DeleteItem(item)"
                  >Delete</a
                >
              </div>
            </div>
          </td>
          <td v-else></td>
        </tr>
      </tbody>
    </table>
    <NoDataAvailable
      v-else
      displayMessage="No Template is available"
    ></NoDataAvailable>
    <DeleteSingleProductConfirmModal
      @deleteSelectedProducts="deleteAction"
      :notDeleted="false"
      delHeaderMsg="Delete Template"
    ></DeleteSingleProductConfirmModal>
    <PreviewTemplate
      :previewTemplateData="previewTemplateData"
      @closePopUp="closePopUp"
    />
  </div>
</template>


<script>
import NoDataAvailable from "../NoDataAvailable.vue";
import DeleteSingleProductConfirmModal from "@/components/product/DeleteSingleProductConfirmModal";
import PreviewTemplate from "./PreviewTemplate.vue";

var moment = require("moment");

export default {
  name: "TemplateListGrid",
  props: [],
  components: {
    NoDataAvailable,
    DeleteSingleProductConfirmModal,
    PreviewTemplate,
  },
  data() {
    return {
      itemToDel: "",
      itemType: "",
      previewTemplateData: {},
    };
  },
  filters: {
    formatDate(data) {
      return moment(data).format("MM/DD/YYYY");
    },
  },
  computed: {
    templateList: {
      set(val) {
        this.$store.commit("template/getTemplateList", val);
      },
      get() {
        return this.$store.state.template.templateList;
      },
    },
    sort: {
      set(val) {
        this.$store.commit("setSelectedSortOrder", val);
      },
      get() {
        return this.$store.state.selectedSortOrder;
      },
    },
  },
  mounted() {},
  methods: {
    editItem(data) {
      let path = "/editTemplate" + "/" + data.id;
      this.$router.push({ path: path });
    },
    DeleteItem(data) {
      this.itemToDel = data.id;
      this.itemType = data.type;
      $("#confirmSingleDeleteProduct").modal({ show: true });
    },
    deleteAction() {
      let payload = {
        id: this.itemToDel,
        itemType: this.itemType,
      };
      let vm = this;
      this.$store.dispatch("template/deleteTemplate", payload).then((res) => {
        vm.itemToDel = "";
        vm.itemType = "";
        vm.$emit("getList");
      });
    },
    showPreview(item) {
      this.previewTemplateData = JSON.parse(JSON.stringify(item));
      $("#previewModal").modal("show");
    },
    closePopUp() {
      this.previewTemplateData = {};
      $("#previewModal").modal("hide");
    },
    sorting(field, event) {
      if (
        event.currentTarget.children[0].classList[2] == "fa-arrow-up" ||
        event.currentTarget.children[0].classList[2] == "fa-arrow-down"
      ) {
        var pastEvent = true;
      }
      for (var i = 0; i < document.getElementsByClassName("sort").length; i++) {
        document
          .getElementsByClassName("sort")
          [i].classList.remove("fa-arrow-up");
        document
          .getElementsByClassName("sort")
          [i].classList.remove("fa-arrow-down");
      }
      if (pastEvent) {
        this.sort.order == "desc"
          ? event.currentTarget.children[0].classList.add("fa-arrow-up")
          : event.currentTarget.children[0].classList.add("fa-arrow-down");
        pastEvent = false;
      } else {
        event.currentTarget.children[0].classList.add("fa-arrow-up");
      }

      this.sort = {
        field: field,
        order:
          event.currentTarget.children[0].classList[2] == "fa-arrow-up"
            ? "asc"
            : "desc",
      };
    },
  },
};
</script>

<style lang="scss">
</style>
